import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { Avatar } from '~/components/Avatar';
import type { User } from '~/modules/auth';

interface Props {
  user: User;
}

function UserDetails({ user }: Props) {
  const { t } = useTranslation('my-profile');

  const props = useMemo(
    () => [
      { key: t('organization'), value: user.profile?.organization },
      { key: t('role'), value: '' }, // TODO: get from the API
      { key: t('userType'), value: user.userType },
      { key: t('email'), value: user.email },
      { key: t('labelGroup'), value: '' }, // TODO: get from the API
    ],
    [t, user],
  );

  return (
    <div className="flex items-center gap-2xl">
      <Avatar name={user.name} size="xl" />
      <div>
        <h1 className="mb-sm text-display-md font-bold">{user.name}</h1>
        <dl className="columns-2 text-body-sm">
          {props.map(({ key, value }) => (
            <div key={key} className="flex gap-md">
              <dt className="text-subtle">{key}</dt>
              <dd className="max-w-full overflow-hidden text-ellipsis text-end">
                {value}
              </dd>
            </div>
          ))}
        </dl>
      </div>
    </div>
  );
}

UserDetails.displayName = 'UserDetails';

export { UserDetails };
